import { Guid } from "guid-typescript";

class TTSDebouncer {
    private wait: number = 500;
    private token: Guid = null;
    private usecCallback: Function = null;

    constructor(wait: number) {
        this.wait = wait;
    }

    private initiate = (callToken: Guid) => {
        setTimeout(() => {
            if (callToken === this.token)
            this.usecCallback();
        }, this.wait);
    }

    call(callback: Function) {
        let newToken = Guid.create();
        this.token = newToken;
        this.usecCallback = callback;
        this.initiate(newToken);
    }
}

export default TTSDebouncer;